import { render } from "./SelectComponent.vue?vue&type=template&id=6d075943&ts=true"
import script from "./SelectComponent.vue?vue&type=script&lang=ts"
export * from "./SelectComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__